export const PROMO_PATH = '/promo/';

export const PROMO_CDN_PATH =
  'https://cdn.leroymerlin.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/promo';

export const PROMO_ELEMENT_BLOCK = 'promoSection';

export const PROMO_LANDING_NAME = 'promo';

export const PROMO_BANNER = {
  bgColor: '#000000',
  elementBlock: PROMO_ELEMENT_BLOCK,
  content: {
    media: {
      alt: 'Акции для профессионалов',
      srcD: `${PROMO_CDN_PATH}/banner/banner-d.png/banner-d.png`,
      srcT: `${PROMO_CDN_PATH}/banner/banner-t.png/banner-t.png`,
      src: `${PROMO_CDN_PATH}/banner/banner-m.png/banner-m.png`,
    },
    title: 'Делаете ремонт профессионально?',
    text: 'Посмотрите акции для профессионалов и\u00A0юрлиц',
  },
  link: {
    href: '/biznes/akcii/',
    title: 'Акции для бизнеса',
  },
  promotion: {
    name: 'promoSectionBottom',
    creative: 'Делаете ремонт профессионально?',
    position: '1',
  },
};
